import { SvgWrapper } from "./SvgWrapper";
import { BaseIcon } from "./types";

export const MdiExpandView = (props: BaseIcon) => (
  <SvgWrapper {...props}>
    <path d="M8.275 11.7L4 7.425V11H2V4H9V6H5.4L9.7 10.275L8.275 11.7ZM4 20C3.45 20 2.97917 19.8042 2.5875 19.4125C2.19583 19.0208 2 18.55 2 18V13H4V18H12V20H4ZM20 13V6H11V4H20C20.55 4 21.0208 4.19583 21.4125 4.5875C21.8042 4.97917 22 5.45 22 6V13H20ZM22 15V20H14V15H22Z" />
  </SvgWrapper>
);
